import { render, staticRenderFns } from "./market-price-futures.vue?vue&type=template&id=67d3c8a8&scoped=true&"
import script from "./market-price-futures.vue?vue&type=script&lang=js&"
export * from "./market-price-futures.vue?vue&type=script&lang=js&"
import style0 from "./market-price-futures.vue?vue&type=style&index=0&lang=css&"
import style1 from "./market-price-futures.vue?vue&type=style&index=1&id=67d3c8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3c8a8",
  null
  
)

export default component.exports